var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiSmilingFaceWithHeartEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 40.0002C11.018 40.0002 0.248779 33.7391 0.248779 20.0002C0.248779 6.26142 11.018 0.000244141 21.0001 0.000244141C26.5457 0.000244141 31.662 1.82493 35.4545 5.1523C39.569 8.80167 41.7515 13.9537 41.7515 20.0002C41.7515 26.0468 39.569 31.163 35.4545 34.8124C31.662 38.1398 26.51 40.0002 21.0001 40.0002Z",
    fill: "url(#paint0_radial_390_2475)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1343 8.11157C40.0413 11.1885 41.0359 14.8522 41.0359 18.9273C41.0359 24.9738 38.8534 30.0901 34.7389 33.7395C30.9464 37.0669 25.7944 38.9273 20.2846 38.9273C13.823 38.9273 7.04663 36.2976 3.04663 30.7198C6.89636 37.0382 14.1379 40.0007 21.0001 40.0007C26.51 40.0007 31.662 38.1402 35.4545 34.8128C39.569 31.1635 41.7515 26.0472 41.7515 20.0007C41.7515 15.4425 40.51 11.3924 38.1343 8.11157Z",
    fill: "#EB8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2865 27.2984C20.0056 27.2984 18.7355 27.0837 17.5298 26.6544C16.045 26.1427 14.4314 26.9334 13.9197 28.4147C13.6299 29.2519 13.748 30.1749 14.2382 30.912C15.7766 33.2733 18.2096 34.5613 21.2865 34.5613C24.3634 34.5613 26.7963 33.2733 28.3348 30.912C29.2042 29.6061 28.8464 27.8422 27.5405 26.9728C26.8035 26.4826 25.8804 26.3646 25.0432 26.6544C23.8375 27.0837 22.5673 27.2984 21.2865 27.2984Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.4816 29.4106C13.9396 29.4106 16.7428 26.7675 16.7428 23.5072C16.7428 20.2468 13.9396 17.6038 10.4816 17.6038C7.02368 17.6038 4.22046 20.2468 4.22046 23.5072C4.22046 26.7675 7.02368 29.4106 10.4816 29.4106Z",
    fill: "url(#paint1_radial_390_2475)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M32.0913 29.4106C35.5492 29.4106 38.3524 26.7675 38.3524 23.5072C38.3524 20.2468 35.5492 17.6038 32.0913 17.6038C28.6333 17.6038 25.8301 20.2468 25.8301 23.5072C25.8301 26.7675 28.6333 29.4106 32.0913 29.4106Z",
    fill: "url(#paint2_radial_390_2475)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7391 9.79369C33.8017 8.96721 31.6443 11.3679 31.6443 11.3679C31.6443 11.3679 31.3938 8.64521 28.8822 7.79011C25.8697 6.75612 22.689 8.40192 22.4994 12.6703C22.2847 17.5325 28.7176 23.9153 28.7176 23.9153C28.7176 23.9153 36.7033 21.7686 39.3187 17.2177C41.4475 13.5146 38.9609 10.4162 36.7391 9.79369Z",
    fill: "#F44336"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7393 9.79354C36.3779 9.69694 36.0058 9.65401 35.6337 9.66117C36.6856 10.366 37.5192 11.3499 38.038 12.502C38.5425 13.7148 38.6749 15.2819 37.716 17.1531C35.6373 21.2211 29.2366 23.7399 28.7715 23.9152C29.3547 23.7506 36.818 21.6039 39.3332 17.2283C41.4477 13.5145 38.9611 10.4161 36.7393 9.79354Z",
    fill: "#C62828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6413 11.8076C31.6198 11.4355 31.5625 11.0634 31.4767 10.6985C31.2692 9.64661 30.618 8.73426 29.6878 8.19401C29.0509 7.82192 28.3461 7.58578 27.6162 7.49634C27.6162 7.49634 28.6896 7.82192 29.4552 9.30671C29.8452 10.0867 30.0777 10.9382 30.135 11.8076C30.1314 12.126 30.1887 12.4373 30.3032 12.7343C30.432 13.0312 30.7468 13.2065 31.0688 13.1564C31.559 13.0312 31.6663 12.4194 31.6413 11.8076Z",
    fill: "#C62828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.685 10.101C25.3541 9.27093 26.4525 8.48024 27.5043 9.21011C28.0625 9.60009 28.0696 10.7056 27.3863 11.203C26.2342 12.0473 26.1805 12.6019 26.0517 13.067C25.8943 13.6216 25.7941 14.2835 25.2897 14.5625C24.7852 14.8416 24.3415 14.5625 24.0768 13.7647C23.626 12.5196 23.855 11.1314 24.685 10.101Z",
    fill: "#FF847A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8142 7.71772C9.91261 8.65869 9.44749 11.8537 9.44749 11.8537C9.44749 11.8537 7.73014 9.70699 5.15411 10.4011C2.08077 11.2097 0.345528 14.3438 2.53873 17.9968C5.07898 22.1828 13.9663 23.9181 13.9663 23.9181C13.9663 23.9181 19.4224 17.707 19.079 12.4691C18.7963 8.20431 15.0074 7.00574 12.8142 7.71772Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.814 7.71774C12.4598 7.83223 12.1199 7.99681 11.8086 8.20433C13.0751 8.2079 14.3131 8.56569 15.3864 9.23832C16.4812 9.95388 17.458 11.199 17.7013 13.292C18.2272 17.8322 14.2916 23.4745 13.9875 23.8859C14.3846 23.4279 19.4043 17.5031 19.0751 12.4655C18.7961 8.20433 15.0072 7.00576 12.814 7.71774Z",
    fill: "#C62828"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69399 12.2289C9.47217 11.9248 9.22172 11.6457 8.94265 11.3953C8.19131 10.6296 7.15016 10.2217 6.08039 10.279C5.34694 10.3219 4.6278 10.5115 3.96948 10.8443C3.96948 10.8443 5.04283 10.5187 6.50258 11.3344C7.26465 11.7745 7.92655 12.3649 8.45607 13.0661C8.6278 13.3344 8.84963 13.5634 9.11081 13.7459C9.38272 13.9212 9.7405 13.889 9.98022 13.6708C10.2986 13.2844 10.0518 12.7191 9.69399 12.2289Z",
    fill: "#C62828"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96817 14.6694C2.98248 14.3689 3.03615 14.0719 3.12559 13.7857C3.27228 13.1846 3.69804 12.6873 4.26691 12.4476C4.81432 12.2759 5.57282 12.3975 5.8662 12.9449C6.12738 13.4315 5.93775 14.0183 5.79464 14.5549C5.66584 15.1703 5.59428 15.8 5.57997 16.4297C5.58355 16.9449 5.1721 17.3635 4.6569 17.3707C4.17031 17.3707 3.79106 16.9485 3.51915 16.5442C3.1399 15.9932 2.9467 15.3385 2.96817 14.6694Z",
    fill: "#FF847A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_390_2475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0001 20.0002) scale(20.3791 20.3791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_390_2475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4816 20.7918) scale(6.82357 6.12729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_390_2475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2952 901.822) scale(6.96243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmilingFaceWithHeartEyes);
export default __webpack_public_path__ + "static/media/emoji-smiling-face-with-heart-eyes.95b7de4a3b23d6752c932087326f0178.svg";
export { ForwardRef as ReactComponent };